import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { UtilitariosService } from '../../../services/utilitarios.service';
import { AuthService } from '../../../services/auth.service';
import { InsuranceTableComponent } from '../../../componentes/insurance-table/insurance-table.component';
import { TableConfig } from '../../../interfaces/table-config.interface';
import { ExportarComponent } from "../../../componentes/exportar/exportar.component";
import { FormsModule } from '@angular/forms';
import { RentCarListResponse } from '../../../interfaces/utilitarios.interface';
import { ApiResponse } from '../../../interfaces/common.interfaces';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-rent-car-afiliados',
  imports: [ExportarComponent, InsuranceTableComponent, FormsModule],
  templateUrl: './rent-car-afiliados.component.html',
  styleUrl: './rent-car-afiliados.component.css',
})
export class RentCarAfiliadosComponent implements OnInit {
  rentCar!: RentCarListResponse[];
  rentCarZones: string[] = [];
  selectedZone: string = 'Todos';
  filteredRentCar: RentCarListResponse[] = [];
  mensajeNoData: string = 'Selecciona los campos que deseas buscar';
  errorStatus?: number;
  title: string = '';


constructor(
  private authService: AuthService,
  private utilitariosService: UtilitariosService,
  private gAnalytics: GoogleAnalyticsService
) {
  this.title = 'Rent Car Afiliados';
}


// Referencia al componente de la tabla
@ViewChild(InsuranceTableComponent) tablaComponent!: InsuranceTableComponent;

  // Configuración de la tabla
  tableConfig: TableConfig = {
    columns: [
      {
        key: 'providerName',
        label: 'Nombre',
        sortable: true,
      },
      {
        key: 'providerPhone',
        label: 'Telefono',
      },
      {
        key: 'providerAddress',
        label: 'Dirección',
      },
    ],
    showTotals: true,
  };


  ngOnInit() {
    const request = {
      producerNumber: this.authService.getProducerNumber() || 0,
    };

    this.utilitariosService.getRentCar(request).subscribe({
      next: (response: ApiResponse<RentCarListResponse[]>) => {
        // Extraer y almacenar las zonas únicas, incluyendo 'Todos' al inicio
        this.rentCarZones = [
          'Todos',
          ...new Set(response.data.map((rentCar) => rentCar.workShopZone || '')),
        ];
        this.rentCar = response.data;
        this.handleSelectedZoneChange();
      },
      error: (error) => {
        console.error('Error al cargar rent car:', error);
        if (error.status === 404) {
          window.alert('No se encontraron datos de contactos');
        }
      },
    });
  }

  handleSelectedZoneChange() {
    if (this.selectedZone === 'Todos') {
      this.filteredRentCar = this.rentCar;
    } else {
      this.filteredRentCar = this.rentCar.filter(
        (rentCar) => rentCar.workShopZone === this.selectedZone
      );
    }

    // Reiniciar la página a 1 cuando cambie la zona
    if (this.tablaComponent) {
      this.tablaComponent.currentPage = 1;
      this.tablaComponent.updatePaginatedData();
    }
  }

  // Exportar datos
  onExportar(formato: string): void {
    if (this.tablaComponent) {
      const headerInfo = {
        titulo: 'Talleres Afiliados',
        fecha1: new Date(),
        tableConfig: this.tableConfig,
        lob: '',
        slob: '',
      };

      //Evento para trackear las exportaciones de archivos en Google Analytics
      this.gAnalytics.trackEvent('rent_car_afiliados_descargas',{
        page:'/rent-car-afiliados',
        format:formato
      })

      this.tablaComponent.exportarDatos(formato, headerInfo);
    }
  }



}